import React from "react";

function HoParallelLine({ size = 24, color = "currentColor", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" aria-labelledby="title" {...props}>
      <g fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
        <path d="M5 18 L18 5" />
        <path d="M8 21 L21 8" />
      </g>
    </svg>
  );
}

export default HoParallelLine;
